// Import des services API spécialisés
import { authService } from './auth';
import { documentService } from './documents';
import { searchService } from './search';
import { cloudService } from './cloud';
import { evaluationService } from './evaluation';
import { contentService } from './content';
import { projectService } from './projects';

// Export des services API spécialisés
export { authService } from './auth';
export { documentService } from './documents';
export { searchService } from './search';
export { cloudService } from './cloud';
export { evaluationService } from './evaluation';
export { contentService } from './content';
export { projectService } from './projects';

// Export des types
export * from './base';

// Classe ApiService principale pour la compatibilité
export class ApiService {
  // Méthodes d'authentification
  setToken = authService.setToken.bind(authService);
  clearToken = authService.clearToken.bind(authService);
  isAuthenticated = authService.isAuthenticated.bind(authService);
  logout = authService.logout.bind(authService);

  // Méthodes de connexion
  login = authService.login.bind(authService);
  refreshToken = authService.refreshToken.bind(authService);
  getCurrentUser = authService.getCurrentUser.bind(authService);

  // Méthodes de documents
  getDocuments = documentService.getDocuments.bind(documentService);
  uploadDocument = documentService.uploadDocument.bind(documentService);
  deleteDocument = documentService.deleteDocument.bind(documentService);
  updateDocument = documentService.updateDocument.bind(documentService);
  getDocumentStats = documentService.getDocumentStats.bind(documentService);
  
  // Méthodes de projets (maintenant via projectService)
  getProjects = projectService.getProjects.bind(projectService);
  createProject = projectService.createProject.bind(projectService);
  updateProject = projectService.updateProject.bind(projectService);
  deleteProject = projectService.deleteProject.bind(projectService);
  getMyProjects = projectService.getMyProjects.bind(projectService);
  getProjectStats = projectService.getProjectStats.bind(projectService);
  
  // Méthodes d'équipes
  getTeams = projectService.getTeams.bind(projectService);
  createTeam = projectService.createTeam.bind(projectService);
  updateTeam = projectService.updateTeam.bind(projectService);
  deleteTeam = projectService.deleteTeam.bind(projectService);

  // Méthodes de recherche
  searchDocuments = searchService.searchDocuments.bind(searchService);
  getSearchSuggestions = searchService.getSearchSuggestions.bind(searchService);
  summarizeSearchResults = searchService.summarizeSearchResults.bind(searchService);
  getSearchStats = searchService.getSearchStats.bind(searchService);
  getSearchHistory = searchService.getSearchHistory.bind(searchService);

  // Méthodes cloud
  getCloudProviders = cloudService.getCloudProviders.bind(cloudService);
  getCloudConnections = cloudService.getCloudConnections.bind(cloudService);
  getAuthUrl = cloudService.getAuthUrl.bind(cloudService);
  handleOAuthCallback = cloudService.handleOAuthCallback.bind(cloudService);
  deleteCloudConnection = cloudService.deleteCloudConnection.bind(cloudService);
  syncCloudFiles = cloudService.syncCloudFiles.bind(cloudService);
  getCloudFiles = cloudService.getCloudFiles.bind(cloudService);
  getCloudFolders = cloudService.getCloudFolders.bind(cloudService);
  updateSyncFolders = cloudService.updateSyncFolders.bind(cloudService);
  getSyncTasks = cloudService.getSyncTasks.bind(cloudService);
  getSyncLogs = cloudService.getSyncLogs.bind(cloudService);
  getCloudStats = cloudService.getCloudStats.bind(cloudService);

  // Méthodes d'évaluation
  getEvaluationProjects = evaluationService.getEvaluationProjects.bind(evaluationService);
  createEvaluationProject = evaluationService.createEvaluationProject.bind(evaluationService);
  updateEvaluationProject = evaluationService.updateEvaluationProject.bind(evaluationService);
  deleteEvaluationProject = evaluationService.deleteEvaluationProject.bind(evaluationService);
  getEvaluationStats = evaluationService.getEvaluationStats.bind(evaluationService);

  // Méthodes de création de contenu
  getContentProjects = contentService.getContentProjects.bind(contentService);
  createContentProject = contentService.createContentProject.bind(contentService);
  updateContentProject = contentService.updateContentProject.bind(contentService);
  deleteContentProject = contentService.deleteContentProject.bind(contentService);
  getDesignTemplates = contentService.getDesignTemplates.bind(contentService);
  getStoryTemplates = contentService.getStoryTemplates.bind(contentService);
  generateVisual = contentService.generateVisual.bind(contentService);
  createPresentation = contentService.createPresentation.bind(contentService);
  generateContent = contentService.generateContent.bind(contentService);
  getContentStats = contentService.getContentStats.bind(contentService);
  getContentAnalytics = contentService.getContentAnalytics.bind(contentService);
}

// Instance singleton pour la compatibilité
export const apiService = new ApiService();
